import type { BrandOption, RevalidationsSortOption } from './revalidationsShared.types'
import type { RevalidationItem } from '~/store-v2/revalidations/revalidationList.types'
import { RevalidationStatus } from '~/services-v2/financial-bff/__generated__/zeus'

export const BRAND_OTHER_VALUE = '__other__'

export const BATCH_SELECTION_UNAVAILABLE_TOOLTIP
  = 'Filtre por uma marca de inversor para utilizar a opção de selecionar revalidações para envio em lote.'

export const BATCH_BLOCKED_STATUSES = new Set([
  RevalidationStatus.INVALID_DATA,
  RevalidationStatus.WAITING_COMMISSIONING_RESULT,
])

/** Statuses counted in brand chips and listed when filtering by brand. */
export const BRAND_CHIP_STATUSES: readonly RevalidationStatus[] = [
  RevalidationStatus.PENDING_SUBMISSION,
  RevalidationStatus.INVALID_DATA,
]

export const STATUS_LABELS: Record<RevalidationStatus, string> = {
  [RevalidationStatus.PENDING_SUBMISSION]: 'Pendente',
  [RevalidationStatus.INVALID_DATA]: 'Dados incorretos',
  [RevalidationStatus.WAITING_COMMISSIONING_RESULT]: 'Em análise',
  [RevalidationStatus.APPROVED]: 'Concluída',
}

export const SORT_OPTIONS: RevalidationsSortOption[] = [
  { label: 'Nome do projeto (A-Z)', order_by: 'project_name', order_dir: 'asc' },
  { label: 'Nome do projeto (Z-A)', order_by: 'project_name', order_dir: 'desc' },
  { label: 'Status (A-Z)', order_by: 'status', order_dir: 'asc' },
  { label: 'Status (Z-A)', order_by: 'status', order_dir: 'desc' },
]

export const INFINITE_SCROLL_ROOT_MARGIN = '200px'

export function normalizeBrandKey(raw: string | null | undefined): string {
  return (raw ?? '').trim().toLowerCase().replace(/_/g, '-')
}

export function formatBrandDisplay(raw: string): string {
  const s = raw.trim().replace(/[_-]/g, ' ').toLowerCase()
  if (!s)
    return 'marca desconhecida'
  return s.replace(/\b\w/g, c => c.toUpperCase())
}

export function getLatestAttemptBrand(item: Pick<RevalidationItem, 'latest_attempts'>): string | null {
  const attempts = item.latest_attempts ?? []
  if (attempts.length === 0)
    return null
  const brand = attempts[attempts.length - 1]?.brand?.trim()
  return brand || null
}

export function resolveInverterBrandForItem(item: RevalidationItem): string {
  if (item.status === RevalidationStatus.APPROVED) {
    const fromLatestAttempt = getLatestAttemptBrand(item)
    if (fromLatestAttempt)
      return fromLatestAttempt
  }
  return item.reference_inverter_brand ?? ''
}

export function resolveBrandOptionForRawBrand(
  rawBrand: string,
  brandOptions: BrandOption[],
  brandOtherValue: string,
): { brand: BrandOption | undefined, customBrand: string } {
  const normalized = normalizeBrandKey(rawBrand)
  const matchedBrand = brandOptions.find(o => o.value === normalized)
  if (matchedBrand)
    return { brand: matchedBrand, customBrand: '' }

  const trimmed = rawBrand.trim()
  if (trimmed) {
    const other = brandOptions.find(o => o.value === brandOtherValue)
    if (other)
      return { brand: other, customBrand: trimmed }
  }

  return { brand: undefined, customBrand: '' }
}
